import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/forms': 'Forms',
  '/attendance': 'Attendance',
  '/crews': 'Crews',
  '/settings': 'Settings',
  '/forms/jha': 'Job Hazard Assessment',
  '/forms/shop-inspection': 'Shop Inspection',
  '/forms/building-inspection': 'Building Inspection',
  '/forms/civil-inspection': 'Civil Inspection',
  '/forms/hse-weekly-report': 'HSE Weekly Report',
};

const BASE_TITLE = 'IDL Safety Tool';

/**
 * Hook to update the browser tab title based on the current route
 */
export function useDocumentTitle() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;

    // Try exact match first
    let pageTitle = PAGE_TITLES[pathname];

    // If no exact match, try to find a partial match for nested routes
    if (!pageTitle) {
      const matchingKey = Object.keys(PAGE_TITLES).find(key =>
        pathname.startsWith(key) && key !== '/'
      );
      if (matchingKey) {
        pageTitle = PAGE_TITLES[matchingKey];
      }
    }

    // Set the document title
    if (pageTitle) {
      document.title = `${pageTitle} | ${BASE_TITLE}`;
    } else {
      document.title = BASE_TITLE;
    }
  }, [location.pathname]);
}
